/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAvailableFeaturesControllerFindAllQueryResponse,
  TelegramAvailableFeaturesControllerFindAllQueryParams,
} from '../../types/TelegramAvailableFeaturesControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramAvailableFeaturesFindAll } from '../../methods/telegramAvailableFeaturesFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramAvailableFeaturesFindAllQueryKey = (
  params?: TelegramAvailableFeaturesControllerFindAllQueryParams,
) => [{ url: '/api/telegram/available-features' }, ...(params ? [params] : [])] as const;

export type TelegramAvailableFeaturesFindAllQueryKey = ReturnType<typeof telegramAvailableFeaturesFindAllQueryKey>;

export function telegramAvailableFeaturesFindAllQueryOptions(
  params?: TelegramAvailableFeaturesControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramAvailableFeaturesFindAllQueryKey(params);
  return queryOptions<
    TelegramAvailableFeaturesControllerFindAllQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramAvailableFeaturesControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramAvailableFeaturesFindAll(params, config);
    },
  });
}

/**
 * {@link /api/telegram/available-features}
 */
export function useTelegramAvailableFeaturesFindAll<
  TData = TelegramAvailableFeaturesControllerFindAllQueryResponse,
  TQueryData = TelegramAvailableFeaturesControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramAvailableFeaturesFindAllQueryKey,
>(
  params?: TelegramAvailableFeaturesControllerFindAllQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramAvailableFeaturesControllerFindAllQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramAvailableFeaturesFindAllQueryKey(params);

  const query = useQuery(
    {
      ...telegramAvailableFeaturesFindAllQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
